import { render, staticRenderFns } from "./BaseSelectInput.vue?vue&type=template&id=8f13e546&scoped=true&"
import script from "./BaseSelectInput.vue?vue&type=script&lang=js&"
export * from "./BaseSelectInput.vue?vue&type=script&lang=js&"
import style0 from "./BaseSelectInput.vue?vue&type=style&index=0&id=8f13e546&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f13e546",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VFlex,VIcon})


/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import ClickOutside from 'vuetify/lib/directives/click-outside'
installDirectives(component, {ClickOutside})
